// 和 ReduceStep 用一个
import { memo } from 'react'
import BasicStep from '../BasicStep/BasicStep'
import type { PopconfirmProps } from 'antd'
const AIGCStep = ({ step }: any) => {
  const LIST = [{ label: '上传内容' }, { label: '选择段落' }, { label: '查看结果' }]
  const onConfirm: PopconfirmProps['onConfirm'] = e => {
    console.log(e)
  }
  return <BasicStep list={LIST} step={step} isGradient={true} confirm={onConfirm} />
}

export default memo(AIGCStep)
